import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-stone-50 pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-73">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-74">
          <div className="max-w-2xl" data-id="element-75">
            <div className="inline-flex items-center space-x-2 bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-medium mb-6" data-id="element-76">
              <StarIcon className="w-4 h-4 fill-current" data-id="element-77" />
              <span data-id="element-78">El Blueprint de 15 Minutos</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-stone-900 leading-tight mb-6" data-id="element-79">
              Deja de pedir perdón por el{' '}
              <span className="text-orange-600 italic" data-id="element-80">estado de tu casa</span>
            </h1>

            <p className="text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-81">
              El sistema de "Rescate Visual" diseñado para padres y
              profesionales ocupados que necesitan una casa presentable HOY, sin
              pasar horas limpiando.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-82">
              <Button size="lg" className="group" scrollTo="pricing" data-id="element-83">
                Quiero el Blueprint Ahora
                <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-84" />
              </Button>
              <p className="text-sm text-stone-500 flex items-center justify-center sm:justify-start mt-4 sm:mt-0 sm:ml-4" data-id="element-85">
                Descarga inmediata • PDF
              </p>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-86">
            <div className="absolute inset-0 bg-orange-200 rounded-3xl transform rotate-3 scale-105 opacity-50 blur-lg" data-id="element-87"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hygnebUyYjWenmYxVQBcmi/El_metodo_casa_limpia_15_minutos.png" alt="El Método Casa Limpia: 15 Minutos - eBook en iPad y iPhone" className="relative rounded-2xl shadow-2xl w-full object-cover z-10 border border-stone-200/50" data-id="element-88" />
          </div>
        </div>
      </div>
    </section>;
}